/* Custom Input Component to be used with Formik */
import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {
  Text, FormErrorMessage, FormFieldInfo, TimePicker
} from 'components/atoms';
import { useFieldError } from 'hooks'

// this spacing is used below the error message, this makes the margin feel more natural
// when the error happears and disappears
const InputSpacingFix = styled.div`
  height: ${props => props.theme.spacing.m};
  width: 100%;
`;

const FieldTimePicker = ({
  title,
  field, // { name, value, onChange, onBlur }
  form: {
    touched, errors, setFieldValue, setFieldTouched, submitCount,
  }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  info,
  ...props
}) => {
  const isError = useFieldError({
    touched, errors, field, submitCount
  })

  // removing on blur and on focus
  // eslint-disable-next-line
  const { onBlur, onFocus, ...fieldRest } = field

  return (
    <Wrapper
      role="button"
      tabindex="0"
      onBlur={() => setFieldTouched(field.name, true)}
    >
      <Top>
        {title && <Text modifiers={['base']}>{title}</Text>}
        <TimePicker
          isError={isError}
          id={field.name}
          {...fieldRest}
          onChange={(value) => {
            setFieldValue(field.name, value)
          }}
          {...props}
        />
      </Top>
      {isError && <FormErrorMessage>{errors[field.name]}</FormErrorMessage>}
      {info && <FormFieldInfo>{info}</FormFieldInfo>}
      <InputSpacingFix />
    </Wrapper>
  );
};

FieldTimePicker.propTypes = {
  title: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func,
  }).isRequired,
  info: PropTypes.string,
};

FieldTimePicker.defaultProps = {
  title: null,
  info: null,
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: 100%;
  ${Text} {
    padding-right: ${props => props.theme.spacing.xs};
  }
`;

export default FieldTimePicker
